import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { useHistory } from "react-router-dom";
import { requestServer } from '../../services/request.js';

import Header, { NavLink, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";
// import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";
import { ReactComponent as Package } from "feather-icons/dist/icons/package.svg";
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import SelectSearch from 'react-select-search';

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }effect
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-orange-500`}
  }
`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url("https://www.devsnews.com/template/logio/logio/assets/img/slider/01.jpg");
`;

const FormContainer = tw.div`w-full flex-1 mt-8 bg-white p-8 rounded shadow-xl`;
const Form = tw.form`mx-auto border border-gray-200 border-t-2 border-b-0 border-l-0 border-r-0`;
const TrackForm = tw.form`text-sm flex flex-col lg:flex-row`
const Input = tw.input`border border-gray-400 px-4 py-3 focus:outline-none font-medium transition duration-300 hocus:border-orange-500`
const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-orange-500 text-gray-100 w-full py-4 rounded hover:bg-orange-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-orange-500 opacity-0`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-5 pb-20 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-5 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-orange-500 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute bg-gray-100 transform -z-10`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-orange-500 font-medium text-sm`;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 text-orange-500 font-bold rounded shadow transition duration-300 hocus:bg-orange-500 hocus:text-gray-100 focus:shadow-outline`;

// const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
//   padding-bottom: 56.25% !important;
//   padding-top: 0px !important;
//   ${tw`rounded`}
//   iframe {
//     ${tw`rounded bg-black shadow-xl`}
//   }
// `;

export default ({
  submitButtonText = "Book A Courier",
  SubmitButtonIcon = Package,
  tosUrl = "#",
  privacyPolicyUrl = "#",
  signInUrl = "#"
}) => {
  const [lite, setLite] = useState("international")
  const [dSize] = useState([
    { name: '0.5', value: '0.5' },
    { name: '1.0', value: '1.0' },
    { name: '1.5', value: '1.5' },
    { name: '2.0', value: '2.0' }])

  const [size] = useState([
    { name: '0.5', value: '0.5' },
    { name: '1.0', value: '1.0' },
    { name: '1.5', value: '1.5' },
    { name: '2.0', value: '2.0' },
    { name: '2.5', value: '2.5' },
    { name: '3.0', value: '3.0' },
    { name: '3.5', value: '3.5' },
    { name: '4.0', value: '4.0' },
    { name: '4.5', value: '4.5' },
    { name: '5.0', value: '5.0' },
    { name: '5.5', value: '5.5' },
    { name: '6.0', value: '6.0' },
    { name: '6.5', value: '6.5' },
    { name: '7.0', value: '7.0' },
    { name: '7.5', value: '7.5' },
    { name: '8.0', value: '8.0' },
    { name: '8.5', value: '8.5' },
    { name: '9.0', value: '9.0' },
    { name: '9.5', value: '9.5' },
    { name: '10.0', value: '10.0' },
    { name: '10.5', value: '10.5' },

    { name: '11.0', value: '11.0' },
    { name: '11.5', value: '11.5' },
    { name: '12.0', value: '12.0' },
    { name: '12.5', value: '12.5' },
    { name: '13.0', value: '13.0' },
    { name: '13.5', value: '13.5' },
    { name: '14.0', value: '14.0' },
    { name: '14.5', value: '14.5' },
    { name: '15.0', value: '15.0' },
    { name: '15.5', value: '15.5' },
    { name: '16.0', value: '16.0' },
    { name: '16.5', value: '16.5' },
    { name: '17', value: '17' },
    { name: '17.5', value: '17.5' },
    { name: '18.0', value: '18.0' },
    { name: '18.5', value: '18.5' },
    { name: '19.0', value: '19.0' },
    { name: '19.5', value: '19.5' },
    { name: '20.0', value: '20.0' },
    { name: '20.5', value: '20.5' },

    { name: '21.0', value: '21.0' },
    { name: '21.5', value: '21.5' },
    { name: '22.0', value: '22.0' },
    { name: '22.5', value: '22.5' },
    { name: '23.0', value: '23.0' },
    { name: '23.5', value: '23.5' },
    { name: '24.0', value: '24.0' },
    { name: '24.5', value: '24.5' },
    { name: '25.0', value: '25.0' },
    { name: '25.5', value: '25.5' },
    { name: '26.0', value: '26.0' },
    { name: '26.5', value: '26.5' },
    { name: '27.0', value: '27.0' },
    { name: '27.5', value: '27.5' },
    { name: '28.0', value: '28.0' },
    { name: '28.5', value: '28.5' },
    { name: '29.0', value: '29.0' },
    { name: '29.5', value: '29.5' },
    { name: '30', value: '30' },
    { name: '30.5', value: '30.5' },

    { name: '31', value: '31' },
    { name: '31.5', value: '31.5' },
    { name: '32', value: '32' },
    { name: '32.5', value: '32.5' },
    { name: '33', value: '33' },
    { name: '33.5', value: '33.5' },
    { name: '34', value: '34' },
    { name: '34.5', value: '34.5' },
    { name: '35', value: '35' },
    { name: '35.5', value: '35.5' },
    { name: '36', value: '36' },
    { name: '36.5', value: '36.5' },
    { name: '37', value: '37' },
    { name: '37.5', value: '37.5' },
    { name: '38', value: '38' },
    { name: '38.5', value: '38.5' },
    { name: '39.0', value: '39.0' },
    { name: '39.5', value: '39.5' },
    { name: '40.0', value: '40.0' },
    { name: '40.5', value: '40.5' },

    { name: '41.0', value: '41.0' },
    { name: '41.5', value: '41.5' },
    { name: '42', value: '42' },
    { name: '42.5', value: '42.5' },
    { name: '43', value: '43' },
    { name: '43.5', value: '43.5' },
    { name: '44', value: '44' },
    { name: '44.5', value: '44.5' },
    { name: '45', value: '45' },
    { name: '45.5', value: '45.5' },
    { name: '46', value: '46' },
    { name: '46.5', value: '46.5' },
    { name: '47', value: '47' },
    { name: '47.5', value: '47.5' },
    { name: '48', value: '48' },
    { name: '48.5', value: '48.5' },
    { name: '49', value: '49' },
    { name: '49.5', value: '49.5' },
    { name: '50', value: '50' },
    { name: '50.5', value: '50.5' },

    { name: '51', value: '51' },
    { name: '51.5', value: '51.5' },
    { name: '52', value: '52' },
    { name: '52.5', value: '52.5' },
    { name: '53', value: '53' },
    { name: '53.5', value: '53.5' },
    { name: '54', value: '54' },
    { name: '54.5', value: '54.5' },
    { name: '55', value: '55' },
    { name: '55.5', value: '55.5' },
    { name: '56', value: '56' },
    { name: '56.5', value: '56.5' },
    { name: '57', value: '57' },
    { name: '57.5', value: '57.5' },
    { name: '58', value: '58' },
    { name: '58.5', value: '58.5' },
    { name: '59', value: '59' },
    { name: '59.5', value: '59.5' },
    { name: '60', value: '60' },
    { name: '60.5', value: '60.5' },

    { name: '61', value: '61' },
    { name: '61.5', value: '61.5' },
    { name: '62', value: '62' },
    { name: '62.5', value: '62.5' },
    { name: '63', value: '63' },
    { name: '63.5', value: '63.5' },
    { name: '64', value: '64' },
    { name: '64.5', value: '64.5' },
    { name: '65', value: '65' },
    { name: '65.5', value: '65.5' },
    { name: '66', value: '66' },
    { name: '66.5', value: '66.5' },
    { name: '67', value: '67' },
    { name: '67.5', value: '67.5' },
    { name: '68', value: '68' },
    { name: '68.5', value: '68.5' },
    { name: '69', value: '69' },
    { name: '69.5', value: '69.5' },
    { name: '70', value: '70' },
    { name: 'More than 70', value: '>70' }
  ])

  const [weight] = useState([
    { name: '0.5', value: '0.5' },
    { name: '1', value: '1' },
    { name: '1.5', value: '1.5' },
    { name: '2', value: '2' },
    { name: '2.5', value: '2.5' },
    { name: '3', value: '3' },
    { name: '3.5', value: '3.5' },
    { name: '4', value: '4' },
    { name: '4.5', value: '4.5' },
    { name: '5', value: '5' },
    { name: '5.5', value: '5.5' },
    { name: '6', value: '6' },
    { name: '6.5', value: '6.5' },
    { name: '7', value: '7' },
    { name: '7.5', value: '7.5' },
    { name: '8', value: '8' },
    { name: '8.5', value: '8.5' },
    { name: '9', value: '9' },
    { name: '9.5', value: '9.5' },
    { name: '10', value: '10' },
    { name: '10.5', value: '10.5' },

    { name: '11', value: '11' },
    { name: '11.5', value: '11.5' },
    { name: '12', value: '12' },
    { name: '12.5', value: '12.5' },
    { name: '13', value: '13' },
    { name: '13.5', value: '13.5' },
    { name: '14', value: '14' },
    { name: '14.5', value: '14.5' },
    { name: '15', value: '15' },
    { name: '15.5', value: '15.5' },
    { name: '16', value: '16' },
    { name: '16.5', value: '16.5' },
    { name: '17', value: '17' },
    { name: '17.5', value: '17.5' },
    { name: '18', value: '18' },
    { name: '18.5', value: '18.5' },
    { name: '19', value: '19' },
    { name: '19.5', value: '19.5' },
    { name: '20', value: '20' },
    { name: '20.5', value: '20.5' },

    { name: '21', value: '21' },
    { name: '21.5', value: '21.5' },
    { name: '22', value: '22' },
    { name: '22.5', value: '22.5' },
    { name: '23', value: '23' },
    { name: '23.5', value: '23.5' },
    { name: '24', value: '24' },
    { name: '24.5', value: '24.5' },
    { name: '25', value: '25' },
    { name: '25.5', value: '25.5' },
    { name: '26', value: '26' },
    { name: '26.5', value: '26.5' },
    { name: '27', value: '27' },
    { name: '27.5', value: '27.5' },
    { name: '28', value: '28' },
    { name: '28.5', value: '28.5' },
    { name: '29', value: '29' },
    { name: '29.5', value: '29.5' },
    { name: '30', value: '30' },
    { name: '30.5', value: '30.5' },

    { name: '31', value: '31' },
    { name: '31.5', value: '31.5' },
    { name: '32', value: '32' },
    { name: '32.5', value: '32.5' },
    { name: '33', value: '33' },
    { name: '33.5', value: '33.5' },
    { name: '34', value: '34' },
    { name: '34.5', value: '34.5' },
    { name: '35', value: '35' },
    { name: '35.5', value: '35.5' },
    { name: '36', value: '36' },
    { name: '36.5', value: '36.5' },
    { name: '37', value: '37' },
    { name: '37.5', value: '37.5' },
    { name: '38', value: '38' },
    { name: '38.5', value: '38.5' },
    { name: '39', value: '39' },
    { name: '39.5', value: '39.5' },
    { name: '40', value: '40' },
    { name: '40.5', value: '40.5' },

    { name: '41', value: '41' },
    { name: '41.5', value: '41.5' },
    { name: '42', value: '42' },
    { name: '42.5', value: '42.5' },
    { name: '43', value: '43' },
    { name: '43.5', value: '43.5' },
    { name: '44', value: '44' },
    { name: '44.5', value: '44.5' },
    { name: '45', value: '45' },
    { name: '45.5', value: '45.5' },
    { name: '46', value: '46' },
    { name: '46.5', value: '46.5' },
    { name: '47', value: '47' },
    { name: '47.5', value: '47.5' },
    { name: '48', value: '48' },
    { name: '48.5', value: '48.5' },
    { name: '49', value: '49' },
    { name: '49.5', value: '49.5' },
    { name: '50', value: '50' },
    { name: 'More than 50', value: '>50' }
  ])

  const [track, setTrack] = useState("")
  const [doc, setDoc] = useState("TRUE")
  const [l, setL] = useState("")
  const [w, setW] = useState("")
  const [h, setH] = useState("")
  const [num, setNum] = useState("")
  const [mode, setMode] = useState("ROAD")
  const [country, setCountry] = useState()
  const [city, setCity] = useState()

  const [countries, setCountries] = useState([])
  const [cities, setCities] = useState([])

  let history = useHistory();
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(country);
    console.log(doc);
    console.log(num);

    const load = (doc === "FALSE") ? {
      "api_name": "getPricing",
      "data": {
        "countryname": country,
        "isdocument": doc,
        "volumetricParam": { "l": l, "w": w, "h": h },
        "packagesize": num
      }
    }
      :
      {
        "api_name": "getPricing",
        "data": {
          "countryname": country,
          "isdocument": doc,
          "packagesize": num
        }
      }

    console.log(load);

    history.push({
      pathname: '/list-vendors',
      state: load
    });
  }

  const handleDomesticSubmit = (e) => {
    e.preventDefault();
    console.log(city);
    console.log(mode);
    console.log(num);

    const load = {
      "api_name": "getDomesticPricing",
      "data": {
        "sector": city,
        "mode": mode,
        "volumetricParam": { "l": l, "w": w, "h": h },
        "weight": num
      }
    }

    console.log(load);

    history.push({
      pathname: '/show-price',
      state: load
    });
  }

  const handleTrack = (e) => {
    e.preventDefault();
    console.log(track);

    const load = {
      "api_name": "generateTrackingLink",
      "data": {
        "id": track
      }
    }
    requestServer(load).then((res) => {
      window.open(res.data.trackLink, '_top');
    }).catch((err) => {
      console.log(err)
    })

  }

  const listCities = () => {
    const load = {
      "api_name": "getCities",
      "data": {
        "mode": mode
      }
    }

    requestServer(load).then((res) => {
      // setProcess(true)
      const data = res.data.data.map(dt => { return { "name": dt, "value": dt } })
      setCities(data)
      // console.log(data);
    }).catch((err) => {
      // setProcess(true)
      console.log(err)
    })
  }

  const listCountries = () => {
    const load = {
      "api_name": "getCountryList"
    }

    requestServer(load).then((res) => {
      // setProcess(true)
      const data = res.data.data.map(dt => { return { "name": dt.countryname, "value": dt.countryname } })
      setCountries(data)
      // console.log(data);
    }).catch((err) => {
      // setProcess(true)
      console.log(err)
    })
  }

  useEffect(() => {
    listCities()
    // return () => {

    // }
  }, [mode, lite])

  useEffect(() => {
    listCountries()
    // return () => {

    // }
  }, [])

  const navLinks = [
    // <NavLinks key={1}>
    //   <NavLink href="#">
    //     About
    //   </NavLink>
    //   <NavLink href="#">
    //     Blog
    //   </NavLink>
    //   <NavLink href="#">
    //     Locations
    //   </NavLink>
    //   <NavLink href="#">
    //     Pricing
    //   </NavLink>
    // </NavLinks>,
    // <NavLinks key={2}>
    //   <OrangeLink href="/#">
    //     Book Now
    //   </OrangeLink>
    // </NavLinks>
  ];

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <TwoColumn>
          <LeftColumn>
            <Notification>PRICE STARTS @ 199 INR</Notification>
            <Heading>
              <span>Choose the best</span>
              <br />
              <SlantedBackground>Courier Partner</SlantedBackground>
            </Heading>
            <PrimaryAction><a href="tel:9500048558">Talk to us</a></PrimaryAction>

          </LeftColumn>
          <RightColumn>
            {/* <StyledResponsiveVideoEmbed
              url="https://youtube.com/embed/hlc2qwDiGJk"
              background="transparent"
            /> */}
            <FormContainer>
              <TrackForm onSubmit={handleTrack}>
                <Input type="text" placeholder="Tracking ID" value={track} onChange={dt => { setTrack(dt.target.value) }} />
                <SubmitButton tw="mt-2 sm:mt-0 ml-0 sm:ml-2" type="submit">Track Now</SubmitButton>
              </TrackForm>
            </FormContainer>
            <FormContainer>
              <div tw="flex">
                <p css={[tw`py-2 cursor-pointer w-1/2 text-center transition-colors hover:text-orange-500`, lite === "international" && tw`border border-orange-400 text-orange-500 border-b-2 border-t-0 border-l-0 border-r-0`]} onClick={() => setLite("international")}>International</p>
                <p css={[tw`py-2 cursor-pointer w-1/2 text-center transition-colors hover:text-orange-500`, lite === "domestic" && tw`border border-orange-400 text-orange-500 border-b-2 border-t-0 border-l-0 border-r-0`]} onClick={() => setLite("domestic")}>Domestic</p>
              </div>
              {lite === "international" && <Form onSubmit={handleSubmit}>
                <SelectSearch
                  options={countries}
                  onChange={dt => { setCountry(dt) }}
                  name="country"
                  placeholder="Choose your country"
                  search
                  emptyMessage={() => <div style={{ textAlign: 'center', color: '#ED8936', padding: '5px 10px' }}>Not found</div>}
                />

                <RadioGroup value={doc} onChange={dt => { setDoc(dt); }} horizontal>
                  <RadioButton value="TRUE" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    <p className="selext">Document</p>
                  </RadioButton>
                  <RadioButton value="FALSE" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    <p className="selext">Parcel</p>
                  </RadioButton>
                </RadioGroup>

                {doc === "FALSE" && <div tw="grid grid-cols-3 gap-2 mt-6">
                  <Input type="text" placeholder="L" value={l} onChange={dt => { setL(dt.target.value) }} />
                  <Input type="text" placeholder="W" value={w} onChange={dt => { setW(dt.target.value) }} />
                  <Input type="text" placeholder="H" value={h} onChange={dt => { setH(dt.target.value) }} />
                </div>}

                <SelectSearch onChange={dt => { setNum(dt) }} options={doc === "TRUE" ? dSize : size} name="package" placeholder="Select your package size" />

                <SubmitButton type="submit" disabled={country !== null & num !== "" ? false : true}>
                  <SubmitButtonIcon className="icon" />
                  <span className="text">{submitButtonText}</span>
                </SubmitButton>

                <p tw="mt-8 text-sm text-gray-600 text-center">
                  Book without registering, urgent delivery at no extra cost
                </p>
              </Form>}
              {lite === "domestic" && <Form onSubmit={handleDomesticSubmit}>

                <RadioGroup value={mode} onChange={dt => setMode(dt)} horizontal tw="mt-6">
                  <RadioButton value="ROAD" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    Road
                  </RadioButton>
                  <RadioButton value="AIR" iconSize={20} padding={15} rootColor={"#d2d2d2"} pointColor={"#ED8936"}>
                    Air
                  </RadioButton>
                </RadioGroup>

                <SelectSearch
                  options={cities}
                  onChange={dt => { setCity(dt) }}
                  name="city"
                  placeholder="Choose your city"
                  search
                  emptyMessage={() => <div style={{ textAlign: 'center', color: '#ED8936', padding: '5px 10px' }}>Not found</div>}
                />

                <div tw="grid grid-cols-3 gap-2 mt-6">
                  <Input type="text" placeholder="L" value={l} onChange={dt => { setL(dt.target.value) }} />
                  <Input type="text" placeholder="W" value={w} onChange={dt => { setW(dt.target.value) }} />
                  <Input type="text" placeholder="H" value={h} onChange={dt => { setH(dt.target.value) }} />
                </div>

                <SelectSearch onChange={dt => { setNum(dt) }} options={weight} name="package" placeholder="Select your package weight" />

                <SubmitButton type="submit" disabled={city !== null & num !== "" ? false : true}>
                  <SubmitButtonIcon className="icon" />
                  <span className="text">{submitButtonText}</span>
                </SubmitButton>

                <p tw="mt-8 text-sm text-gray-600 text-center">
                  Book without registering, urgent delivery at no extra cost
                </p>
              </Form>}
            </FormContainer>
          </RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
